export default __webpack_public_path__ + "static/media/weight.02ebd256.svg";